import { ClockIcon } from "lucide-react";

import { UserAvatar } from "@/components/common/user-avatar";
import { useMembers } from "@/contexts/member-context";

import { DetailField, DetailGrid, DetailSection, fmtDateTime } from "./detail";

/** Created/updated audit block, shared across every show page. */
export function SystemSection({
  record,
}: {
  record: {
    createdBy?: string | null;
    updatedBy?: string | null;
    createdAt?: string | number | null;
    updatedAt?: string | number | null;
  };
}) {
  const { members } = useMembers();

  const memberFor = (id?: string | null) =>
    id
      ? members.find(
          (m) => m.id === id || m.adminMetadata?.relatedIds?.includes(id),
        )
      : undefined;

  const createdMember = memberFor(record.createdBy);
  const updatedMember = memberFor(record.updatedBy);

  return (
    <DetailSection title="System" icon={<ClockIcon className="size-4" />}>
      <DetailGrid>
        <DetailField label="Created by">
          {createdMember ? (
            <UserAvatar {...createdMember} half />
          ) : (
            record.createdBy
          )}
        </DetailField>
        <DetailField label="Created at" value={fmtDateTime(record.createdAt)} />
        <DetailField label="Updated by">
          {updatedMember ? (
            <UserAvatar {...updatedMember} half />
          ) : (
            record.updatedBy
          )}
        </DetailField>
        <DetailField label="Updated at" value={fmtDateTime(record.updatedAt)} />
      </DetailGrid>
    </DetailSection>
  );
}
